import {
  supabaseClient,
} from "../../services/supabase";

import type {
  Client,
  NewClient,
} from "./types";


export type EditClientInput = {
  id: string;

  nome: string;

  telefone?: string | null;

  nivel?: string | null;

  observacao?: string | null;
};


export async function loadClients(): Promise<
  Client[]
> {
  const {
    data,
    error,
  } =
    await supabaseClient
      .from(
        "clientes",
      )
      .select("*")
      .eq(
        "ativo",
        true,
      )
      .order(
        "nome",
      );


  if (error) {
    throw error;
  }


  return (
    data ??
    []
  ) as Client[];
}


export async function createClient(
  client: NewClient,
): Promise<Client> {
  const {
    data,
    error,
  } =
    await supabaseClient
      .from(
        "clientes",
      )
      .insert({
        nome:
          client.nome.trim(),

        telefone:
          client.telefone
            ?.trim() ||
          null,

        nivel:
          client.nivel ||
          null,

        observacao:
          client.observacao
            ?.trim() ||
          null,

        ativo:
          true,
      })
      .select("*")
      .single();


  if (error) {
    throw error;
  }


  return data as Client;
}


export async function editClient(
  input: EditClientInput,
): Promise<Client> {
  const cleanName =
    input.nome.trim();

  if (!cleanName) {
    throw new Error(
      "Informe o nome do cliente.",
    );
  }


  const {
    data,
    error,
  } =
    await supabaseClient
      .from(
        "clientes",
      )
      .update({
        nome:
          cleanName,

        telefone:
          input.telefone
            ?.trim() ||
          null,

        nivel:
          input.nivel ||
          null,

        observacao:
          input.observacao
            ?.trim() ||
          null,

        updated_at:
          new Date()
            .toISOString(),
      })
      .eq(
        "id",
        input.id,
      )
      .select("*")
      .single();


  if (error) {
    throw error;
  }


  return data as Client;
}